import { render, staticRenderFns } from "./superiorityContent.vue?vue&type=template&id=7846b3f6&"
import script from "./superiorityContent.vue?vue&type=script&lang=js&"
export * from "./superiorityContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports